import utils from '@utils';

export const send = async (b: ConactCreateBody) => {
  const res = await utils.axios.slsGo().post('/contacts', b);

  return res.data;
};
